/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

export interface BalanceDto {
  assetId?: number;
  asset?: Asset;
  total?: number;
  credit?: number;
}
